export default __webpack_public_path__ + "static/media/basket3081797.6ca36c59.svg";